<template>
  <div class="mian-article">
        <Header/>
      <div class="width1200">
        <div class="box">
          <h1>{{ $t('header.LaboratoryIntroduction') }}</h1>
          <p>{{ $t('about.p2') }}</p>
          <p>{{ $t('about.p3') }}</p>
          <p>{{ $t('about.p4') }}</p>
          <p>{{ $t('about.p5') }}</p>
          <p>{{ $t('about.p6') }}</p>
        </div>
        </div>
            <Footer/>
  </div>
</template>

<script>
import Header from "@/components/Header"
import Footer from "@/components/Footer"
export default {
    components:{
        Header,
        Footer
    },
    data(){
        return {

        }
    }
}
</script>

<style scoped lang="scss">
    .mian-article{
        @include home_bg_t2_color();
        .width1200{
            width: 100%;
            background-image: url("../../assets/image/aboutUs/bg.png");
            background-repeat: no-repeat;
            background-size: cover;
            @include co_white_to_black();
          .box{
            width: 1400px;
            background-color: #FFFFFF;
            margin: 0 auto;
            padding:  58px 90px;
            box-sizing: border-box;
          }
            h1{
                text-align: center;
            }
            p{
              margin: 24px 0;
              text-indent: 2em;
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #3F444D;
              line-height: 25px;
            }
        }
    }
</style>